import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordPageview } from "../lib/api";

// Fires a lightweight pageview beacon on every route change.
// Bots are filtered server-side; admin routes are also excluded server-side.
export default function useAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Give the title/meta a moment to update so referrer is meaningful
    const t = setTimeout(() => {
      recordPageview({
        path: pathname || "/",
        referrer: document.referrer || "",
      }).catch(() => {
        /* silently ignore - analytics must never break the site */
      });
    }, 150);
    return () => clearTimeout(t);
  }, [pathname]);
}
